import React from 'react';
import { Breadcrumbs, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { Link, useLocation } from 'react-router-dom';
import KenColors from '../../Helpers/Themes/kenColors';

const useStyles = makeStyles((theme) => ({
  mainText: {
    fontWeight: '600 !important',
    textDecoration: 'none',
    textTransform: 'capitalize',
    margin: '0px !important',
    padding: '0px !important',
    background: '#f5f8fb',
  },
  listText: {
    textDecoration: 'none',
    textTransform: 'capitalize',
    margin: '0px !important',
    padding: '0px !important',
    background: '#f5f8fb',
  },
}));

const AppBreadCrumbs: React.FunctionComponent = () => {
  const { pathname, state } = useLocation();
  const classes = useStyles();

  console.log(state?.breadCrumbs, 'state');

  // Split the current route into parts
  const navigateHistory: Array<string> = pathname.split('/').filter((item) => item && item !== '');

  // Determine the title: Prefer state.breadCrumbs over dynamic title
  const title = state?.breadCrumbs ? state.breadCrumbs : navigateHistory.length > 0 ? navigateHistory[navigateHistory.length - 1].replace(/-/g, ' ') : 'Home';

  return (
    <>
      {/* Render the title */}
      <Typography className={classes.mainText} color={KenColors.ClientBlack2} fontSize={{ xs: '13px', md: '15px', ultraHD: '20px' }}>
        {title}
      </Typography>

      {/* Render breadcrumbs without the last segment */}
      {navigateHistory.length > 1 && (
        <Breadcrumbs separator={<Typography sx={{ fontSize: { xs: '10px', md: '12px', lg: '14px' }, fontWeight: '600' }}>&gt;</Typography>} style={{ color: KenColors.ClientBlack2 }}>
          {/* Add Home as the first breadcrumb */}
          {!navigateHistory.includes('home') && (
            <Link to="/home" className={classes.listText}>
              <Typography
                sx={{
                  color: KenColors.ClientBlack1,
                  fontWeight: '500',
                  fontSize: { xs: '10px', md: '12px', ultraHD: '14px' },
                }}
              >
                Home
              </Typography>
            </Link>
          )}

          {/* Dynamically generate breadcrumbs, excluding the last segment */}
          {navigateHistory.slice(0, -1).map((item, index) => {
            const path = `/${navigateHistory.slice(0, index + 1).join('/')}`;
            return (
              <Link key={index} className={classes.listText} to={path}>
                <Typography
                  sx={{
                    color: KenColors.ClientBlack1,
                    fontWeight: '500',
                    fontSize: { xs: '10px', md: '12px', ultraHD: '14px' },
                  }}
                >
                  {item.replace(/-/g, ' ')}
                </Typography>
              </Link>
            );
          })}
        </Breadcrumbs>
      )}
    </>
  );
};

export default AppBreadCrumbs;
